export enum TripStatus {
  WAITING_DRIVER = 1,
  ON_SPOT = 2,
  DONE = 3,
  ON_GOING = 4,
  CANCELLED = 5,
  DRIVER_ASSIGNED = 6,
  DECLINED = 7,
  UpDATE = 8,
  NOT_TAKEN = 9,
  DRIVER_ON_THE_WAY = 10,
  NO_SHOW = 11,
  APPROVED = 12,
}
